// hooks
import { useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useMapContext } from './context/MapProvider'
// components
import { LayerGroup, LayersControl, Polyline, ZoomControl } from 'react-leaflet'
import { BaseLayers } from './BaseTileLayers'
import LeafletMap from 'common/LeafletMap'
import MapEvents from './MapEvents'
import { FitBoundsToData } from 'common/LeafletMap/controls/FitBoundsToData'
// layers
import MountpointsLayer from './layers/MountpointsLayer'
import ClientsLayer from './layers/ClientsLayer'
import ClientSourceLineLayer from './layers/ClientSourceLineLayer'

const Map = () => {
  const { pathname } = useLocation()

  const { positions, setLinePositions, mountpoints, clients, mapRef } = useMapContext()

  const lineRef = useRef<L.Polyline>(null)

  const isMeasuring = /measurement/i.test(pathname)

  const handleMarkerClick = (latlng: L.LatLng) => {
    if (isMeasuring) {
      if ([0, 2].includes(positions.length)) setLinePositions([latlng])
      else setLinePositions([...positions, latlng])
    }
  }

  return (
    <div style={{ width: '100dvw', height: '100dvh' }}>
      <LeafletMap ref={mapRef}>
        <LayersControl position="bottomleft">
          <BaseLayers />

          <MountpointsLayer mountpoints={mountpoints} onClick={handleMarkerClick} />
          <ClientsLayer clients={clients} onClick={handleMarkerClick} />

          <LayersControl.Overlay name="User Source Line" checked>
            <LayerGroup>
              <ClientSourceLineLayer clients={clients} mountpoints={mountpoints} />
            </LayerGroup>
          </LayersControl.Overlay>

          {isMeasuring && (
            <>
              <Polyline
                ref={lineRef}
                pathOptions={{ dashArray: '5, 5' }}
                positions={positions.length !== 0 ? positions : []}
              />
              <MapEvents
                mapRef={mapRef}
                lineRef={lineRef}
                positions={positions}
                setLinePositions={setLinePositions}
              />
            </>
          )}
        </LayersControl>
        <ZoomControl position="bottomleft" />
        <FitBoundsToData />
      </LeafletMap>
    </div>
  )
}

export default Map
